import React from "react";
import styles from "./work-faster-mobile.module.scss";
import { useTranslation } from "react-i18next";
import iconPlatform from "@/assets/one-platform.svg";
import iconDecisions from "@/assets/faster-desicions.svg";
import iconVisibility from "@/assets/fullp-visibility.svg";
import iconScale from "@/assets/grow-up.svg";

export const WorkFasterMobile: React.FC = () => {
    const { t } = useTranslation();

    const items = [
        {
            icon: iconPlatform,
            title: "One platform instead of emails and spreadsheets",
            text: "Manage ordering without emails, calls or manual coordination"
        },
        {
            icon: iconDecisions,
            title: "Faster decisions with instant alternatives",
            text: "Instant access to analogues, prices and delivery times"
        },
        {
            icon: iconVisibility,
            title: "Full visibility over orders, deliveries",
            text: "Track every order, delivery and document in one place"
        },
        {
            icon: iconScale,
            title: "Built to scale with your business",
            text: "Works for small teams and scales with growing order volumes"
        }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>
                {t("Work faster, with more control and less effort")}
            </h2>
            <p className={styles.subtitle}>
                {t("Expertise you can rely on")}
            </p>

            <div className={styles.content}>
                {items.map((item, index) => (
                    <div key={index} className={styles.item}>
                        <div className={styles.iconContainer}>
                            <img src={item.icon} alt="" className={styles.icon} />
                        </div>
                        <div className={styles.textContainer}>
                            <h3 className={styles.itemTitle}>{t(item.title)}</h3>
                            <p className={styles.itemText}>{t(item.text)}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
